import { ErrorHandler, Injectable } from '@angular/core';

import * as Sentry from '@sentry/browser';
import { environment } from 'src/environments/environment';

// Sentry 11 は sendDefaultPii の代わりに dataCollection で送る範囲を決める。既定は userInfo: true（IP を推定して保存）や
// Cookie・リクエスト本文・GraphQL の変数（登録トークンなどを含む）まで送るので、v9 の既定（sendDefaultPii: false）と同じ範囲に絞る
export const SENTRY_OPTIONS: Sentry.BrowserOptions = {
  dsn: environment.sentry.dsn,
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpBodies: [],
    graphQL: { variables: false },
  },
};

Sentry.init(SENTRY_OPTIONS);

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {}
  handleError(error) {
    if (environment.sentry.using) {
      const eventId = Sentry.captureException(error.originalError || error);
      // Sentry.showReportDialog({ eventId });
    } else {
      throw error;
    }
  }
}
